function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 2.84a2.282 2.282 0 0 1 3.228 3.228L6.438 16.961 2 18.172l1.21-4.438z",
    transform: "translate(-1.25 -1.422)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ed542c70af297c7882694fe6dbf65a14.svg";
export { ForwardRef as ReactComponent };